var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouseCertificate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0037 63.0122H53.1491C56.4654 63.0122 59.1516 60.3261 59.1516 57.0097V11.991C59.1516 10.3343 57.807 8.98975 56.1503 8.98975H50.577C48.9203 8.98975 47.5757 10.3343 47.5757 11.991V18.9119",
    stroke: "#A7C90D",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98865 32.1414L32.0923 12.3391C34.3402 10.4123 37.6566 10.4123 39.9045 12.3391L63.0111 32.1414",
    stroke: "#A7C90D",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6648 48.6753L22.8274 54.5127L19.325 51.0103",
    stroke: "#A7C90D",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81401 53.4499L11.8068 56.058L12.239 59.3024C12.4791 61.1031 13.8927 62.5197 15.6935 62.7598L18.9468 63.195L21.5519 65.1878C22.9925 66.2893 24.9943 66.2893 26.4349 65.1878L29.043 63.195H29.04L32.2874 62.7628C34.0881 62.5227 35.5047 61.1091 35.7448 59.3084L36.18 56.055C36.18 56.058 37.1884 54.7375 38.1728 53.4499C39.2743 52.0093 39.2743 50.0075 38.1728 48.5669L36.18 45.9588L35.7478 42.7145C35.5077 40.9137 34.0941 39.4971 32.2934 39.257L29.04 38.8219L26.4349 36.829C24.9943 35.7276 22.9925 35.7276 21.5519 36.829L18.9438 38.8219H18.9468L15.6995 39.254C13.8987 39.4941 12.4821 40.9077 12.242 42.7085L11.8068 45.9618C11.8068 45.9588 10.7984 47.2794 9.81401 48.5669C8.71255 50.0075 8.71255 52.0063 9.81401 53.4499Z",
    stroke: "#A7C90D",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseCertificate);
export default __webpack_public_path__ + "static/media/house-certificate.f8c3bd1eda93efdf773f40feebe8969a.svg";
export { ForwardRef as ReactComponent };